export const getPercentWorkTypes = (workTypes) =>
  workTypes.reduce((list, workType) => {
    list.push(workType.name);
    return list;
  }, [])
  .join(", ");
